// eslint-ignore
export default 
`<Checkbox
  v-model="checkboxCustom"
  text="I accept the terms and conditions"
  true-value="accepted"
  false-value="not_accepted"
>
</Checkbox>

<p>Value:{{ checkboxCustom }}</p>


export default {
  components: {
    Checkbox
  },

  data () {
    return {
      checkboxCustom: "not_accepted",
    }
  }
}`;